import { render, staticRenderFns } from "./accountList.vue?vue&type=template&id=28f0fa31&scoped=true"
import script from "./accountList.vue?vue&type=script&lang=js"
export * from "./accountList.vue?vue&type=script&lang=js"
import style0 from "./accountList.vue?vue&type=style&index=0&id=28f0fa31&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f0fa31",
  null
  
)

export default component.exports